import PropTypes from 'prop-types';
import React from 'react';
import BuoyIcon from '../Icons/Buoy';
import en from '../../intl/translations/en';

const NearbyBuoysCTA = ({ href, onClickPaywall }) => (
  <div className="sl-nearby-buoys-cta">
    <div className="sl-nearby-buoys-cta__header">{en.premiumCTA.NearbyBuoysCTA.headerText}</div>
    <div className="sl-nearby-buoys-cta__icon-buoy">
      <BuoyIcon />
    </div>
    <div className="sl-nearby-buoys-cta__subheader">
      {en.premiumCTA.NearbyBuoysCTA.subheaderText}
    </div>
    <div className="sl-nearby-buoys-cta__upgrade">
      <a className="sl-nearby-buoys-cta__upgrade__link" href={href} onClick={onClickPaywall}>
        {en.premiumCTA.NearbyBuoysCTA.ctaText}
      </a>
    </div>
    <div className="sl-nearby-buoys-cta__learn-more">
      <a
        className="sl-nearby-buoys-cta__learn-more__link"
        href={en.premiumCTA.NearbyBuoysCTA.learnMoreLink}
      >
        {en.premiumCTA.NearbyBuoysCTA.learnMoreText}
      </a>
    </div>
  </div>
);

NearbyBuoysCTA.defaultProps = {
  href: null,
  onClickPaywall: null,
};

NearbyBuoysCTA.propTypes = {
  href: PropTypes.string,
  onClickPaywall: PropTypes.func,
};

export default NearbyBuoysCTA;
